export default "__VITE_ASSET__BTtGFkWo__"